module.exports = __webpack_public_path__ + "img/cross-red-circle.03513cf9.svg";